import { render, staticRenderFns } from "./team.html?vue&type=template&id=0828863b&scoped=true&"
import script from "./team.js?vue&type=script&lang=js&"
export * from "./team.js?vue&type=script&lang=js&"
import style0 from "./team.scss?vue&type=style&index=0&id=0828863b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828863b",
  null
  
)

export default component.exports